import React, { createContext, useReducer } from 'react';
import TwoCards from '../../../../../components/Card/TwoCards';
import { initialState, reducer, actions } from './reducer';
import SecondaryContent from './SecondaryContent';
import ISContent from './ISContent';
import useTitle from 'hooks/useTitle';

export const store = createContext(null);
const { Provider } = store;

const InsuranceSubtractions = () => {
  useTitle('بیمه بار')
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <Provider value={{ state, dispatch, actions }}>
      <TwoCards
        title="بیمه بار"
        category="تعیین بیمه‌بار برای بازه‌های مختلف ارزش بار"
        secondaryTitle={
          state.commission && state.commission._id ? 'ویرایش' : 'افزودن'
        }
        secondaryContent={<SecondaryContent />}
        secondaryCategory="تعیین مبلغ بیمه برای حداقل و حداکثر مبلغ ارزش بار"
      >
        <ISContent />
      </TwoCards>
    </Provider>
  );
};

export default React.memo(InsuranceSubtractions);
